import { useQuery } from "@tanstack/react-query";
import BannerService from "services/BannerService";

const useGetBanners = (siteId, queryOptions = {}) => {
  return useQuery({
    queryKey: ["getBanners", siteId],
    queryFn: () => BannerService.getBanners(siteId),
    enabled: !!siteId,
    ...queryOptions,
  });
};

export default useGetBanners;
